import {
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import {
  Contactus,
  UseCase,
  ClientMarket,
  ClientIndustry,
  FileDownloadpath
} from 'app/Shared/Model/contactus/contactus-model';

import { ContactusService } from 'app/Shared/Services/Contactus/contactus-service';

import { ConfigLoaderService } from 'app/Shared/Services/Config/config-loader.service';
import { HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { ErrorModel } from 'app/Shared/Model/error/error-model';
import { ErrorServiceService } from 'app/Shared/Services/Error/error-service.service';

declare var $: any;
@Component({
  selector: 'app-docket-form',
  templateUrl: './docket-form.component.html',
  styleUrls: ['./docket-form.component.scss'],
  standalone: false
})
export class DocketFormComponent implements OnInit {

  @ViewChild('contactusform') form!: any;
  contactmodel: Contactus = new Contactus();
  usecaselist!: UseCase[];
  clientmarketlist!: ClientMarket[];
  clientindustrylist!: ClientIndustry[];
  filepath!: FileDownloadpath;
  selectedoffering!: string;
  modalDocketHeader!: string;
  modalDocketSubHeading!: string;
  loading = false;
  showFileDownloadInfo = false;
  showalertMsg = false;
  alertMsg!: string;
  alertmsgClass!: string;
  buttondisable = false;
  errModal: ErrorModel = new ErrorModel();
  successMessage =
    'Thank you for downloading the Pre-requisite docket. Kindly contact the ASD Team if any assistance is required.';

  errorMessage =
    'Error in downloading the Pre-requisite docket. Kindly contact the ASD Team.';

  filedownloadMessage = 'Docket Download is InProgress.';
  filedownloadCompleteMessage = 'Docket Download Completed';
  filedownload = {
    status: '',
    progressPercent: ''
  };

  prereqDocketUrl!: string;
  prereqDocketname!: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DocketFormComponent>,
    private contactService: ContactusService,
    private _errorService: ErrorServiceService
  ) {
    this.filepath = new FileDownloadpath();
    this.errModal = new ErrorModel();
  }

  ngOnInit(): void {
    this.prereqDocketUrl = this.data.prereqDocketUrl;
    this.prereqDocketname = this.data.prereqDocketname;
    this.errModal.ComponentName = 'DocketFormComponent';

    this.selectedoffering = this.data.selectedoffering;
    this.modalDocketHeader =
      `DOWNLOAD ASD – ${this.selectedoffering.toUpperCase()} PRE-REQUISITE DOCKET`;
    this.modalDocketSubHeading =
      'Kindly provide us with the following information to help us serve you better. Please click on Download after filling in the client details.';
    if (ConfigLoaderService.settings.env.name === 'DEVELOPMENT') {
      this.contactmodel.UserId =
        ConfigLoaderService.settings.DevValues.userName;
    } else {
      this.contactmodel.UserId =
        ConfigLoaderService.settings.AppSettings.userId;
    }

    this.getUsecaseList();
    this.getClientMarketList();
    this.getClientIndustryList();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  // formreset(): void {
  //   this.form?.resetForm();
  // }

  getUsecaseList() {
    this.contactService
      .getUsecaseList(this.contactmodel.UserId)
      .subscribe((data: any) => {
        this.usecaselist = data;
      });
  }

  getClientMarketList() {
    this.contactService
      .getClientMarketList(this.contactmodel.UserId)
      .subscribe((data: any) => {
        this.clientmarketlist = data;
      });
  }

  getClientIndustryList() {
    this.contactService
      .getClientIndustryList(this.contactmodel.UserId)
      .subscribe((data: any) => {
        this.clientindustrylist = data;
      });
  }

  onSubmit() {
    this.loading = true;
    if (!this.form?.valid) {
      this.form.control.markAllAsTouched();
      return;
    }

    this.showFileDownloadInfo = true;

    this.errModal.MethodName = 'Submit';
    this.errModal.ErrorMessage = 'Error on Submitting Contact';

    this.contactmodel.AppType =
      this.selectedoffering.toUpperCase();

    this.contactService.submitDetails(this.contactmodel).subscribe(
        (data: any) => {
          // console.log('Submit Response', data);
          // console.log('Contact Model', this.contactmodel);
          if (!data?.body?.length) {
            this.showFileDownloadInfo = false;
            this.alertmsgClass = 'alert alert-danger';
            this.alertMsg =
              'API returned no file information.';
            this.showalertMsg = true;
            console.error('API returned empty body',data);
            return;
          }
          this.loading = true;
          $("#filedownloadsuccess").toast("show");
          this.alertmsgClass = 'alert alert-info';
          this.alertMsg = this.filedownloadMessage;
          this.showalertMsg = true;

          this.buttondisable = true;

          this.filepath.Filepath =
            data.body[0].filepath;

          this.filepath.Filename =
            data.body[0].filename;

          this.downloadFile('');

        },

        (error) => {

          this.showFileDownloadInfo = false;

          this.alertmsgClass =
            'alert alert-danger';

          this.alertMsg =
            'Error while submitting details';

          this.showalertMsg = true;

          this._errorService.handleError(
            error,
            this.errModal
          );

        }

      );
  }

  downloadFile(linkName: string = '') {
    this.showFileDownloadInfo = true;
    this.filepath.Filepath = this.prereqDocketUrl;
    this.filepath.Filename = this.prereqDocketname;
    this.contactService.getFile(this.filepath)
      .subscribe((data) => {
        const message = this.getStatusMessage(data, linkName);
        if (message.toLowerCase() === 'done') {
          this.filedownload.progressPercent = '100';
          this.loading = false;
          this.showFileDownloadInfo = false;
          $("#success").toast("show");
          this.alertmsgClass = 'alert alert-success';
          this.alertMsg = this.successMessage;
          this.showalertMsg = true;
          this.formreset();
          this.buttondisable = false;
        }
      },
        (err: any) => {
          this.errModal.ErrorMessage = 'Error on saving file';
          $("#error").toast("show");
          this.showFileDownloadInfo = false;
          this.loading = false;
          this.alertmsgClass = 'alert alert-danger';
          this.alertMsg = this.errorMessage;
          this.showalertMsg = true;
          this.formreset();
          this.buttondisable = false;
          this._errorService.handleError(err, this.errModal);
        }
      );
  }

  getStatusMessage(event: any, linkName: string) {
    let status;

    switch (event.type) {
      case HttpEventType.DownloadProgress:
        status = Math.round(100 * event.loaded / event.total);
        this.filedownload.status = "InProgress"
        this.filedownload.progressPercent = status.toString();
        $("#filedownloadmodalsuccess").toast("show");
        this.alertmsgClass = 'alert alert-info';
        if (linkName == '') {
          this.alertMsg = this.filedownloadMessage
        }
        else {
          this.alertMsg = "Report Download is InProgress";
        }
        this.showalertMsg = true;
        return 'Files are ' + status + '% downloaded';
      case HttpEventType.Response:
        this.generateDownload(event.body!, linkName)
        return 'Done';
      default:
        return 'Something went wrong'
    }
  }

  generateDownload(data: Blob, linkName: string) {
    saveAs(data, this.filepath.Filename); // from file-saver library 
  }

  formreset() {
    this.form.resetForm();
    this.contactmodel.clientmarket = '';
    this.contactmodel.clientindustry = '';
    this.contactmodel.usecase = '';
    this.form?.resetForm(this.contactmodel);
  }
}